import React from "react";
import {
  coachDemoImg,
  CancelIconBlack,
  ClockIconGray,
  LocationIconGray,
  WalletIconGray,
  CalendarIconGray,
} from "../../constant/imagePath";
import css from "./myLessonCardMobile.module.css";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import { Button } from "../Button/Button";

function MyLessonCardMobile({ data, type, onClick1, onClick2 }) {
  return (
    <div
      style={{
        borderBottom: `1px solid ${Colors.neutralShadesOfWhisper} `,
      }}
      className={css.todoLessonCardMainContainer}
    >
      <div className={css.todoLessonCardhead}>
        <div className={css.imageBox}>
          <img src={data?.userData?.photo} alt="" />
        </div>
        {/*  */}
        <div className={css.headings}>
          <h5
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            {data?.requestType}
          </h5>{" "}
          <h5
            className={`${[css.heading].join(" ")}`}
            style={{
              ...Fonts.h4,
              fontSize: "20px",
              lineHeight: "28px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            with {data?.userData?.displayName}
          </h5>
        </div>{" "}
        {/*  */}
      </div>
      <div className={css.todoLessonCardBody}>
        <ul>
          <li className={css.marginTop16}>
            <div>
              <img src={CalendarIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.date}
            </p>
          </li>
          <li className={css.marginTop16}>
            <div>
              <img src={ClockIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.time}
            </p>
          </li>
          <li className={css.marginTop16}>
            <div>
              <img src={LocationIconGray} alt="" />
            </div>
            <p
              style={{
                ...Fonts.p1,
                fontSize: "14px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {data?.location}
            </p>
          </li>
        </ul>
        <p className={css.line}></p>
      </div>
      <div className={css.todoLessonFooter}>
        <p className={css.time} style={{ ...Fonts.p1, fontSize: "14px" }}>
          {data?.timeLeft} left
        </p>
        {data?.type == "pending" ? (
          <div>
            <Button
              customStyle={{
                marginRight: "8px",
              }}
              icon={CancelIconBlack}
              size={"Large"}
              onClick={onClick1}
            />

            <Button
              label={"Accept"}
              customStyle={{
                ...Fonts.b2,
                padding: "14px 54px",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "156px",
              }}
              primary={true}
              size="Large"
              onClick={onClick2}
            />
          </div>
        ) : data?.type == "accepted" ? (
          <div>
            <Button
              customStyle={{
                marginRight: "8px",
              }}
              size={"Large"}
              icon={CancelIconBlack}
              onClick={onClick1}
            />

            <Button
              label={"Cancel"}
              customStyle={{
                ...Fonts.b2,
                padding: "14px 54px",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "156px",
              }}
              primary={false}
              isTertiary={true}
              size="Large"
              onClick={onClick2}
            />
          </div>
        ) : data?.type == "evaluate" ? (
          <div>
            <Button
              label={"Evaluate"}
              customStyle={{
                ...Fonts.b2,
                padding: "0",
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                width: "212px",
              }}
              primary={true}
              size="Large"
              onClick={onClick1}
            />
          </div>
        ) : (
          data?.type == "read-evaluation" && (
            <div>
              <Button
                label={"Read evaluation"}
                customStyle={{
                  ...Fonts.b2,
                  padding: "0",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  width: "212px",
                }}
                primary={false}
                isTertiary={true}
                size="Large"
                onClick={onClick1}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
}

export { MyLessonCardMobile };
